import React, { useState } from "react";
import { Button, Form, Grid, GridRow, Header, Image, Segment } from "semantic-ui-react";
import configs from "../helpers/config";
import loginService from "../services/login.service";
import recuperacaoService from "../services/recuperacao.service";
import LinkButton from "./LinkButton";
import { application_agnostic_auth_token } from "./Login";

const LoginColaborador = ({ setIsLoading }) => {
    const [email, setEmail] = useState("");
    const [senha, setSenha] = useState("");
    const [esqueciSenha, setEsqueciSenha] = useState(false);

    const handleLogin = () => {
        if (email && senha) {
            window.grecaptcha.ready(() => {
                window.grecaptcha.execute(configs.RECAPTCHA_SITE_KEY, { action: "PortalResultadosLoginPaciente" }).then((token) => {
                    setIsLoading(true);
                    loginService
                        .loginColaborador({
                            codigo: email,
                            senha,
                            recaptcha_token: token,
                        })
                        .then(({ data }) => {
                            if (data.success) {
                                const session = {
                                    state: "loggedIn",
                                    username: data.user,
                                    token: data.token,
                                    type: "colaborador",
                                };
                                localStorage.setItem(application_agnostic_auth_token, JSON.stringify(session));
                                window.location.href = configs.CONSULTORIO_URL;
                            } else alert(data.mensagem);
                        })
                        .finally(() => setIsLoading(false));
                });
            });
        } else {
            alert("Insira a os dados de acesso corretamente");
        }
    };

    const handleEsqueciSenha = () => {
        if (email) {
            window.grecaptcha.ready(() => {
                window.grecaptcha.execute(configs.RECAPTCHA_SITE_KEY, { action: "PortalResultadosLoginPaciente" }).then((token) => {
                    setIsLoading(true);
                    recuperacaoService
                        .solicitarAsync({
                            tipo: 9, //colaborador
                            email,
                            recaptcha_token: token,
                        })
                        .then((data) => {
                            if (data.success) {
                                alert("Em instantes você receberá um email com instruções para troca de senha.");
                            } else alert("Não localizamos seu e-mail verifique o endereço informado e tente novamente.");
                        })
                        .catch((error) => {
                            console.log(error);
                            alert("Serviço indisponível, tente novamente mais tarde.");
                        })
                        .finally(() => setIsLoading(false));
                });
            });
        } else {
            alert("Insira a os dados de acesso corretamente");
        }
    };

    return (
        <Segment>
            <Header as="h2">
                <p className="headerLogin">
                    <Image src={require("../img/colaborador.svg")} className="imgAvatarColaborador" avatar />
                    SECRETÁRIA
                </p>
            </Header>

            <Form size="large">
                <GridRow>
                    <p>Acesso direto ao portal de consultorios</p>
                    <Form.Input fluid icon="at" iconPosition="left" placeholder="Email" onChange={(e) => setEmail(e.target.value)} />

                    {!esqueciSenha && (
                        <Form.Input
                            fluid
                            icon="lock"
                            iconPosition="left"
                            placeholder="Senha"
                            type="password"
                            onChange={(e) => setSenha(e.target.value)}
                        />
                    )}

                    <Button fluid size="large" onClick={!esqueciSenha ? handleLogin : handleEsqueciSenha}>
                        {!esqueciSenha ? "ENTRAR" : "SOLICITAR RECUPERAÇÃO"}
                    </Button>
                    <br />
                    <Grid columns={2}>
                        <Grid.Row>
                            <Grid.Column>
                                <LinkButton onClick={() => setEsqueciSenha(true)}>Esqueci minha senha</LinkButton>
                            </Grid.Column>
                        </Grid.Row>
                    </Grid>
                </GridRow>
            </Form>
        </Segment>
    );
};

export default LoginColaborador;
